module.exports = __webpack_public_path__ + "img/tariff-selection-bg--1199.3a9350e.jpg";